export const Expired = time => {
  if (Date.now() >= new Date(time).getTime()) {
    return true
  } else {
    return false
  }
}
